import { generateTreeChips } from 'app/components/AmWorkDesk/PlacementsDesk/filterHelper';
import { notificationFilterName } from '../../Notification/Filters/utils';
import { TabTitle } from '../../PerformanceReport';
import { taskFilterName } from '../../Task/Filters/utils';

export const createFilterChips = (values, t, title: TabTitle) => {
  if (title === TabTitle.communication) {
    return {
      [notificationFilterName.communicationType]: values[notificationFilterName.communicationType]?.length
        ? values[notificationFilterName.communicationType].map(value =>
            generateFieldChips(
              value.value === 'Voice' ? 'Call' : value.value === 'Conversation' ? 'SMS' : value.value,
              value.name,
            ),
          )
        : undefined,
      [notificationFilterName.initiatedBy]: [
        {
          label: 'Me',
          value: 'Me',
          enableDelete: false,
        },
      ],
      [notificationFilterName.communicationDirection]: values[notificationFilterName.communicationDirection]?.length
        ? values[notificationFilterName.communicationDirection].map(value =>
            generateFieldChips(
              value.value === 'Voice' ? 'Call' : value.value === 'Conversation' ? 'SMS' : value.value,
              value.name,
            ),
          )
        : undefined,
      [notificationFilterName.status]: values[notificationFilterName.status]?.length
        ? generateTreeChips([], values[notificationFilterName.status], [], undefined, undefined, undefined, [])
        : undefined,
    };
  }

  if (title === TabTitle.task) {
    return {
      [taskFilterName.category]: values[taskFilterName.category]?.length
        ? values[taskFilterName.category].map(value => generateFieldChips(value.value, value.name))
        : undefined,
      [taskFilterName.assignedTo]: [
        {
          label: 'Me',
          value: 'Me',
          enableDelete: false,
        },
      ],
      [taskFilterName.createdBy]: values[taskFilterName.createdBy]?.length
        ? values[taskFilterName.createdBy].map(value => generateFieldChips(value.value, value.name))
        : undefined,
      [taskFilterName.status]: values[taskFilterName.status]?.length
        ? values[taskFilterName.status].map(value => generateFieldChips(value.value, value.name))
        : undefined,
    };
  }
};

const generateFieldChips = (value, label) => ({
  label: label,
  value: value,
  enableDelete: true,
});
